import {Component, Input} from '@angular/core';
import {Severity} from '../../../../types/severity';

@Component({
  selector: 'mc-alert-chip',
  templateUrl: './alert-chip.component.html',
  styleUrls: ['./alert-chip.component.scss'],
})
export class AlertChipComponent {
  @Input() severity: Severity = 'primary';
}
